module.exports = __webpack_public_path__ + "static/media/stake-head-right.62b1dd34.png";